import './styles.scss'

const Stepper = () => {
  return (
    <>
      <div className="wrapper-progressBar">
        <ul className="progressBar">
          <li className="active"><span className="font-class">Beong Processed</span></li>
          <li className="active"><span className="font-class">Waiting for payment</span></li>
          <li ><span className="font-class">Paid</span></li>
        </ul>
      </div>
    </>
  )
}

export default Stepper;